// extracted by mini-css-extract-plugin
module.exports = {"banner":"z_cm","icon":"z_cc","title":"z_bx","text":"z_cn","button":"z_b1"};